var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { DateTime } from 'luxon';
import classNames from 'classnames';
import { DateTimePicker } from './components/DateTimePicker';
import { useMount } from 'src/shared/hooks/useLifecycle';
import { onClickOutside } from 'src/shared/helpers/viewsHelpers';
import { E_DATE_FORMAT } from 'src/shared/helpers/dateHelpers';
import styles from './dateTimeInput.module.scss';
import { windowExist } from 'src/shared/constants';
import { Icons } from 'src/ui/components/Icons/Icons';
import { E_ICONS } from 'src/ui/components/Icons/constants';
import { DEFAULT_OVERVIEW_FROM_LABEL, DEFAULT_OVERVIEW_TO_LABEL, IDENTIFIER_DATETIME_INPUT, IDENTIFIER_DATETIME_INPUT_VALUE, SHORTCUT_DATES, } from 'src/ui/components/Input/DateTimeInput/constants';
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
export var DateTimeInput = function (props) {
    var _a, _b, _c;
    var i18n = props.i18n, label = props.label, isLabelOnTop = props.isLabelOnTop, startDate = props.startDate, endDate = props.endDate, currentShortcutDate = props.currentShortcutDate, shortcutDates = props.shortcutDates, className = props.className, onDateChange = props.onDateChange;
    var _d = useState(false), pickerOpen = _d[0], setPickerOpen = _d[1];
    var currentShortcutProps = SHORTCUT_DATES.find(function (item) { return item.type === currentShortcutDate; }) || null;
    var _e = useState(currentShortcutProps), currentShortcut = _e[0], setCurrentShortcut = _e[1];
    var _f = useState('toRight'), pickerPosition = _f[0], setPickerPosition = _f[1];
    var dateTimeInputRef = useRef(null);
    var _g = useState({ startDate: null, endDate: null }), tempsDate = _g[0], setTempsDate = _g[1];
    useMount(function () {
        onClickOutside(dateTimeInputRef, function () { return setPickerOpen(false); });
    });
    useEffect(function () {
        setTempsDate({
            startDate: typeof startDate === 'string' ? DateTime.fromISO(startDate) : startDate,
            endDate: typeof endDate === 'string' ? DateTime.fromISO(endDate) : endDate,
        });
    }, [startDate, endDate]);
    useEffect(function () {
        var x = dateTimeInputRef.current.getBoundingClientRect().x;
        if (windowExist) {
            if (x < window.innerWidth / 2 + 125 && x > window.innerWidth / 2 - 125) {
                setPickerPosition('center');
            }
            else if (x > window.innerWidth / 2) {
                setPickerPosition('toLeft');
            }
            else {
                setPickerPosition('toRight');
            }
        }
    }, [pickerOpen]);
    var handleOpenPicker = function () {
        setPickerOpen(!pickerOpen);
    };
    var dateTimePickerClassName = classNames(styles.dateTimePickerWrapper, (_a = {},
        _a[styles.dateTimePickerOpen] = pickerOpen,
        _a[styles.dateTimePickerOnRight] = pickerPosition === 'toRight',
        _a[styles.dateTimePickerOnLeft] = pickerPosition === 'toLeft',
        _a[styles.dateTimePickerOnCenter] = pickerPosition === 'center',
        _a));
    var labelClassName = classNames(styles.label, (_b = {},
        _b[styles.labelOnTop] = isLabelOnTop || startDate || endDate,
        _b));
    var overViewValueWrapperClassName = classNames(styles.overviewValuesWrapper, (_c = {},
        _c[styles.overViewValueWrapperSelected] = pickerOpen,
        _c));
    var fromOverviewLabel = getPropsByKeyPath(i18n === null || i18n === void 0 ? void 0 : i18n.components, 'dateTimeRangeSelectInput.customView.overview.fromLabel') ||
        DEFAULT_OVERVIEW_FROM_LABEL;
    var toOverviewLabel = getPropsByKeyPath(i18n === null || i18n === void 0 ? void 0 : i18n.components, 'dateTimeRangeSelectInput.customView.overview.toLabel') || DEFAULT_OVERVIEW_TO_LABEL;
    var currentShortcutLabel = currentShortcut
        ? getPropsByKeyPath(i18n === null || i18n === void 0 ? void 0 : i18n.components, "dateTimeRangeSelectInput.customLabels.".concat(currentShortcut.labelKey)) ||
            currentShortcut.labelKey
        : null;
    var overviewText = currentShortcutLabel ? (currentShortcutLabel) : DateTime.isDateTime(tempsDate.startDate) && DateTime.isDateTime(tempsDate.endDate) ? (_jsxs(_Fragment, { children: [_jsx("span", __assign({ className: styles.overviewValuesKeyWord }, { children: fromOverviewLabel })), tempsDate.startDate.toLocaleString(E_DATE_FORMAT.DATE), _jsx("span", __assign({ className: styles.overviewValuesKeyWord }, { children: toOverviewLabel })), tempsDate.endDate.toLocaleString(E_DATE_FORMAT.DATE)] })) : null;
    var handleDateChange = function (date) {
        setCurrentShortcut(null);
        onDateChange(date);
    };
    return (_jsxs("div", __assign({ "data-test": IDENTIFIER_DATETIME_INPUT, className: classNames(styles.dateTimeInputWrapper, className), ref: dateTimeInputRef }, { children: [_jsxs("div", __assign({ "data-test": IDENTIFIER_DATETIME_INPUT_VALUE, className: overViewValueWrapperClassName, onClick: handleOpenPicker }, { children: [_jsx("p", __assign({ className: styles.overviewValues }, { children: overviewText })), _jsx("p", __assign({ className: labelClassName }, { children: label })), _jsx(Icons, { className: styles.calendar, icon: E_ICONS.CALENDAR })] })), _jsx(DateTimePicker, { i18n: i18n, startDate: tempsDate.startDate, endDate: tempsDate.endDate, currentShortcut: currentShortcut, shortcutDates: shortcutDates, onShortcutDateClick: setCurrentShortcut, onDateChange: handleDateChange, className: dateTimePickerClassName })] })));
};
